

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Panel from 'vux/src/components/panel/index.vue'

import Confirm from 'vux/src/components/confirm/index.vue'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Loading from 'vux/src/components/loading/index.vue'

import VueClipboard from 'vue-clipboard2'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'




Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('x-header', XHeader)
Vue.component('card', Card)
Vue.component('divider', Divider)
Vue.component('step', Step)
Vue.component('step-item', StepItem)
Vue.component('x-textarea', XTextarea)
Vue.component('x-button', XButton)
Vue.component('box', Box)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('confirm', Confirm)
Vue.component('panel', Panel)
Vue.component('loading', Loading)
Vue.component('qrcode', Qrcode)
Vue.component('x-input', XInput)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.use(ConfirmPlugin)
Vue.use(VueRouter)
Vue.use(VueClipboard)


import home from '@/home'
import rsa from '@/rsa'
import result from '@/result'
import more from '@/more'


const router = new VueRouter({
routes: [
{
path: '/',
name: 'home',
component: home
},
{
path: '/rsa',
name: 'rsa',
component: rsa
},
{
path: '/result',
name: 'result',
component: result
},
{
path: '/more',
name: 'more',
component: more
},
]
})


FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js